import React from 'react';

import { GenericContext } from 'shared/constants';
import { EmptyDiv } from 'shared/functions';

function SkillsSetPreview(props) {
  // @ts-expect-error
  const { settings, loadCustomComponents } = React.useContext(GenericContext);

  const { candidateCustomField, value, schemaProperty } = props;

  const [SkillsTaxonomy, setSkillsTaxonomy] = React.useState(() => EmptyDiv);
  const [selectedSkills, setSelectedSkills] = React.useState({});
  React.useEffect(
    () =>
      setSelectedSkills(
        (value || []).reduce(
          (prev, cur) => ({
            ...prev,
            [cur.skill]: cur.proficiency,
          }),
          {},
        ),
      ),
    [value],
  );

  React.useLayoutEffect(() => {
    loadCustomComponents(settings).then((customComponents) => {
      setSkillsTaxonomy(() => customComponents.SkillsTaxonomy);
    });
  });

  return (
    <div>
      <SkillsTaxonomy
        // @ts-expect-error
        candidateCustomField={candidateCustomField}
        skillValueMax={schemaProperty.items?.properties?.proficiency?.maximum}
        selectedSkills={selectedSkills}
        previewMode
      />
    </div>
  );
}

// eslint-disable-next-line import/no-default-export
export default SkillsSetPreview;
